module.exports = __webpack_public_path__ + "static/media/app-bar-login.7692b2c9.svg";